import { Etablissement } from './../models/Etablissement';
import session from "./mock-db/session.json";
import etablissements from "./mock-db/etablissements.json";
import pointagesHeure from "./mock-db/pointagesHeure.json";
import listIndividus from "./mock-db/listIndividus.json";
import listClasses from "./mock-db/listClasses.json";
import listEcoles from "./mock-db/listEcoles.json";
import listInstit from "./mock-db/listInstit.json";
import listAutorisations from "./mock-db/listAutorisations.json";
import HistoScol from "./mock-db/histoScolarite.json";
import listParents from "./mock-db/listParents.json";
import medecin from "./mock-db/medecin.json";
import maladies from "./mock-db/maladies.json";
import allergies from "./mock-db/allergies.json";
import vaccins from "./mock-db/vaccins.json";
import ActiviteDocuments from "./mock-db/ActiviteDocuments.json";
import TypeActiviteDocuments from "./mock-db/TypeActiviteDocuments.json";
import dossier from "./mock-db/dossier.json"
import infoIndividu from "./mock-db/informationsIndividu.json";
import champLibreResultValeur from './mock-db/champLibreResultValeur.json';
import champLibreValeur from './mock-db/champLibreValeur.json';
import champsLibres from './mock-db/champsLibres.json';
import champsLibresFamille from './mock-db/champsLibresFamille.json';
import champsLibresIndividu from './mock-db/champsLibresIndividu.json';

import { Activite } from "@/models/Activite";
import { TypeActivite } from "@/models/TypeActivite";
import { Individu } from '@/models/Individu';
import { HistoScolarite } from '@/models/HistoScolarite';
import { Autorisations } from '@/models/Autorisations';
import { Parent } from '@/models/Parent';
import { MedecinDocument } from '@/models/MedecinDocument';
import { MaladieDocument } from '@/models/MaladieDocument';
import { AllergieDocument } from '@/models/AllergieDocument';
import { VaccinDocument } from '@/models/VaccinDocument';
import { InformationIndividuDocument } from '@/models/InformationIndividuDocument';
import { ChampLibreResultValeurDocument } from "@/models/ChampLibreResultValeurDocument";
import { ChampLibreValeurDocument } from "@/models/ChampLibreValeurDocument";
import { ChampLibreDocument } from "@/models/ChampLibreDocument";
import { ChampLibreResultDocument } from "@/models/ChampLibreResultDocument";
import { User } from "@/models/User";


import pointagesactifs from "./mock-db/pointageactifs.json";
import tempsAccueil from "./mock-db/TempsAccueil.json";
import palette from "./mock-db/palette.json";
import users from "./mock-db/users.json";

import { IDB } from "./idb";
import { Pointage } from '@/models/Pointage';
import { TarifEventSchedulerActiviteDocument } from '@/models/TarifEventSchedulerActiviteDocument';
import { PaletteDocument } from '@/models/PaletteDocument';
import { GroupeIndividu } from '@/models/GroupeIndividu';
import { Supplement } from '@/models/Supplement';
import { ElementFriseActiviteDocument } from '@/models/ElementFriseActiviteDocument';
import { DossierDocument } from '@/models/DossierDocument';
import { SupplementPointageDocument } from '@/models/SupplementPointageDocument';
import { PointageDetailInoeDocument } from '@/models/PointageDetailInoeDocument';
import { ClasseScolaireDocument } from '@/models/ClasseScolaireDocument';
import { EtablissementScolaireDocument } from '@/models/EtablissementScolaireDocument';
import { EnseignantScolaireDocument } from '@/models/EnseignantScolaireDocument';
class MockDB implements IDB {
  getIndividus(): Individu[] {
    let listInd: Individu[] = []
    listIndividus.forEach(ind => {
      let individu = new Individu(ind);
      listInd.push(individu)
    });
    return listInd;
  }
  getPalette(id: number): PaletteDocument {
    return new PaletteDocument({});
  }
  getGroupe(id: number): GroupeIndividu {
    return new GroupeIndividu({});
  }
  openSession(url: String, username: String, password: String) {
    return new Promise(function (resolve, reject) {
      resolve({ status: 200, data: session });
    });
  }



  login(url: string, user: string, password: string) {
    return new Promise(function (resolve, reject) {
      resolve({ status: 200});
    });
  }
  initLocalDB(): Promise<any> {
    return new Promise(function (resolve, reject) {
      resolve({ status: 200});
    });
  }
  initRemoteDB(url: String, username: String, password: String, withParams: boolean): Promise<any> {
    return new Promise(function (resolve, reject) {
      resolve({ status: 200});
    });
  } 
  getLocalDBSize(): Promise<any> {
    return new Promise(function (resolve, reject) {
      resolve({ status: 200});
    });
  }
  getRemoteDBSize(): Promise<any> {
    return new Promise(function (resolve, reject) {
      resolve({ status: 200});
    });
  }
  checkSecretCode(code: string, etablissementId: number) {
    return new Promise(function (resolve, reject) {
      resolve({ status: 200, data: {} });
    });
  }

  listPointages() {
    let listpointageactifs: Array<Pointage> = []
    return new Promise(function (resolve, reject) {
      pointagesactifs.forEach(element => {
        let pointage = new Pointage(element);
        listpointageactifs.push(pointage)
      });
      resolve(listpointageactifs)
    });
  }
  listPointagesPrevi(date: any, id_activite: number) {
    return new Promise(function (resolve, reject) {
      resolve({ status: 200, data: etablissements });
    });
  }
  listPointagesReel(date: any, id_activite: number) {
    return new Promise(function (resolve, reject) {
      resolve({ status: 200, data: etablissements });
    });
  }
  getPointages(date: any) {
    return new Promise(function (resolve, reject) {
      resolve({ status: 200, data: [] });
    });
  }
  listEtablissements() {
    let listEtablissement: Array<Etablissement> = []
    return new Promise(function (resolve, reject) {
      etablissements.forEach((element: any) => {
        let etablissement = new Etablissement(element);
        listEtablissement.push(etablissement)
      });
      resolve(listEtablissement)
    });
  }

  listUsers() {
    let listUsers: Array<User> = []
    return new Promise(function (resolve) {
      users.forEach((element: any) => {
        let utilisateur = new User(element);
        listUsers.push(utilisateur)
      });
      resolve(listUsers)
    })
  }
  listUsersFromRemote() {
    let listUsers: Array<User> = []
    return new Promise(function (resolve) {
      users.forEach((element: any) => {
        let utilisateur = new User(element);
        listUsers.push(utilisateur)
      });
      resolve(listUsers)
    })
  }
  usersLogged() {
    return new Promise(function (resolve, reject) {
      resolve({ status: 200, data: {} });
    });
  }

  connect() {
    return new Promise(function (resolve, reject) {
      resolve({ status: 200, data: {} });
    });
  }
  ajouterDocument(document: any) {
    return new Promise(function (resolve, reject) {
      resolve({ status: 200, data: {} });
    });
  }
  supprimerDocument(document_Id: any) {
    return new Promise(function (resolve, reject) {
      resolve({ status: 200, data: {} });
    });
  }
  bulkDocuments(listDocuments: Array<any>) {
    return new Promise(function (resolve, reject) {
      resolve({ status: 200, data: {} });
    });
  }
  listIndividusActivite(id_activite: number) {
    var me = this;
    let listInd: Array<Individu> = [];
    return new Promise(function (resolve, reject) {
      listIndividus.forEach(ind => {
        let individu = new Individu(ind);
        //individu.setDb(me);
        individu.setRegimAlimIntitule("Sans sucre")
        listInd.push(individu)
      });
      resolve(listInd);
    });
  }
  listIndividusEtablissement(id_etablissement: number) {
    var me = this;
    let listInd: Array<Individu> = [];
    return new Promise(function (resolve, reject) {
      listIndividus.forEach(ind => {
        let individu = new Individu(ind);
        //individu.setDb(me);
        individu.setRegimAlimIntitule("Sans sucre")
        listInd.push(individu)
      });
      resolve(listInd);
    });
  }
  fetchElementFriseActiviteDocument(id_activite: number) {
    let me = this;
    return new Promise<Array<ElementFriseActiviteDocument>>((resolve, reject) => {
      resolve([])
    })
  }
  listTempsAccueil(id_activite: number, date: any) {
    let listetemps: Array<TarifEventSchedulerActiviteDocument> = [];
    return new Promise(function (resolve, reject) {
      tempsAccueil.forEach(element => {
        let temps = new TarifEventSchedulerActiviteDocument(element);
        temps.setPlageIntitule(element.plageIntitule)
        listetemps.push(temps)
      });
      resolve(listetemps);
    });
  }
  listSupplements(id_activite: number) {
    return new Promise(function (resolve, reject) {
      resolve({ status: 200, data: {} });
    });
  }
  listClasses() {
    let listCla: Array<ClasseScolaireDocument> = [];
    listClasses.forEach(cla => {
      let classes = new ClasseScolaireDocument(cla);
      listCla.push(classes);
    });
    return (listCla)

  }
  listEcoles() {
    let listEco: Array<EtablissementScolaireDocument> = [];
    listEcoles.forEach(ec => {
      let ecole = new EtablissementScolaireDocument(ec);
      listEco.push(ecole)
    });
    return (listEco)

  }
  listInstit() {
    let listInstituteur: Array<EnseignantScolaireDocument> = [];
    listInstit.forEach(instit => {
      let instituteur = new EnseignantScolaireDocument(instit);
      listInstituteur.push(instituteur);
    });
    return (listInstituteur)
  }
  HistoScolarite() {
    let listHisto: Array<HistoScolarite> = [];
    HistoScol.forEach(histo => {
      let histoscola = new HistoScolarite(histo);
      listHisto.push(histoscola);
    });
    return (listHisto);

  }
  listAutorisations() {
    let listAuto: Array<Autorisations> = [];
    return new Promise(function (resolve, reject) {
      listAutorisations.forEach(auto => {
        let autorisation = new Autorisations(auto);
        listAuto.push(autorisation);
      });
      resolve(listAuto);
    });
  }
  listNiveau() {
    return []
  }
  findParents(id_famille: number, id_individu: number) {
    let listpar: Array<Parent> = [];
    return new Promise(function (resolve, reject) {
      listParents.forEach(par => {
        let parent = new Parent(par);
        listpar.push(parent)
      });
      resolve(listpar);
    });
  }
  findMedecin(id_medecin: number) {
    return new Promise(function (resolve, reject) {
      let med = new MedecinDocument(medecin);
      resolve(med);
    });
  }

  findMaladieIndividu(id_individu: number) {
    let listMaladies: Array<MaladieDocument> = [];
    return new Promise(function (resolve, reject) {
      maladies.forEach(mal => {
        let maladie = new MaladieDocument(mal);
        listMaladies.push(maladie);
      });
      resolve(listMaladies);
    });
  }
  findAllergieIndividu(id_individu: number) {
    let listAllergies: Array<AllergieDocument> = [];
    return new Promise(function (resolve, reject) {
      allergies.forEach(all => {
        let allergie = new AllergieDocument(all);
        listAllergies.push(allergie);
      });
      resolve(listAllergies)
    });
  }
  findVaccinIndividu(id_individu: number) {
    let listVaccins: Array<VaccinDocument> = [];
    return new Promise(function (resolve, reject) {
      vaccins.forEach(vac => {
        let vaccin = new VaccinDocument(vac);
        listVaccins.push(vaccin);
      });
      resolve(listVaccins)
    });
  }
  findAutorisations(id_individu: number) {
    let listAuto: Array<Autorisations> = [];
    return new Promise(function (resolve, reject) {
      listAutorisations.forEach(auto => {
        let autorisation = new Autorisations(auto);
        listAuto.push(autorisation);
      });
      resolve(listAuto);
    });
  }
  findChampsLibresFamille(idFamille: number) {
    let champsLibresFamilleObj: Array<ChampLibreResultDocument> = [];
    return new Promise(function (resolve, reject) {
      champsLibresFamille.forEach((element: any) => {
        champsLibresFamilleObj.push(new ChampLibreResultDocument(element))
      });
      resolve(champsLibresFamilleObj);
    });
  }
  findChampsLibresIndividu(idIndividu: number) {
    let champsLibresIndividuObj: Array<ChampLibreResultDocument> = [];
    return new Promise(function (resolve, reject) {
      champsLibresIndividu.forEach((element: any) => {
        champsLibresIndividuObj.push(new ChampLibreResultDocument(element))
      });
      resolve(champsLibresIndividuObj);
    });
  }
  findChampsLibres() {
    let champsLibresObj: Array<ChampLibreDocument> = [];
    return new Promise(function (resolve, reject) {
      champsLibres.forEach((element: any) => {
        champsLibresObj.push(new ChampLibreDocument(element))
      });
      resolve(champsLibresObj);
    });
  }
  findChampLibreValeur() {
    let champsLibresValeursObj: Array<ChampLibreValeurDocument> = [];
    return new Promise(function (resolve, reject) {
      champLibreValeur.forEach((element: any) => {
        champsLibresValeursObj.push(new ChampLibreValeurDocument(element))
      });
      resolve(champsLibresValeursObj);
    });
  }
  findChampLibreResultValeur() {
    let champsLibresResultsValeursObj: Array<ChampLibreResultValeurDocument> = [];
    return new Promise(function (resolve, reject) {
      champLibreResultValeur.forEach((element: any) => {
        champsLibresResultsValeursObj.push(new ChampLibreResultValeurDocument(element));
      });
      resolve(champsLibresResultsValeursObj);
    });
  }

  listTypesActivites() {
    let typeActiviteDocuments: Array<TypeActivite> = []
    TypeActiviteDocuments.forEach((doc: any) => {
      let typeActivite = new TypeActivite(doc)
      typeActiviteDocuments.push(typeActivite)
    });
    return (typeActiviteDocuments);
  }
  findDossier() {
    return new DossierDocument(dossier);
  }
  findInformationIndividu(id_individu: number) {
    let listinfos: Array<InformationIndividuDocument> = [];
    return new Promise(function (resolve, reject) {
      infoIndividu.forEach(info => {
        let informa = new InformationIndividuDocument(info);
        listinfos.push(informa)
      });
      resolve(listinfos)
    });
  }
  listPalette(categorie: string, etablissement_id: number) {
    let listPalette: Array<PaletteDocument> = [];
    return new Promise(function (resolve, reject) {
      palette.forEach((pal: any) => {
        let newpalette = new PaletteDocument(pal);
        listPalette.push(newpalette);
      });
      resolve(listPalette);
    });
  }
  listGroupes(id_activite: number) {
    let listGroupes: Array<GroupeIndividu> = [];
    return new Promise(function (resolve, reject) {
      /*groupes.forEach((grp: any) => {
        let groupe = new GroupeIndividu(grp);
        listGroupes.push(groupe);
      });*/
      resolve(listGroupes);
    });
  }
  listRegimAlim() {
    return new Promise(function (resolve, reject) {
      resolve({ status: 200, data: {} });
    });
  }
  listVille() {
    return [];

  }
  findIndividuAdresse(id_famille: number) {
    return new Promise(function (resolve, reject) {
      resolve({ status: 200, data: {} });
    });
  }

  listSupplementsActifs(date: any) {
    return new Promise(function (resolve, reject) {
      resolve({ status: 200, data: {} });
    });
  }

  listSupplementsHeureActifs(date: any) {
    return new Promise(function (resolve, reject) {
      resolve({ status: 200, data: {} });
    });
  }

  listSupplementPrevi(date: any, id_activite: number) {
    return new Promise(function (resolve, reject) {
      resolve({ status: 200, data: {} });
    });
  }
  sync(config: any): any {
    return new Promise(function (resolve, reject) {
      resolve({ status: 200, data: {} });
    });
  }
  reset(): any {
    return new Promise(function (resolve, reject) {
      resolve({ status: 200, data: {} });
    });
  }
  getPointageDetailInoe(id: number) {
    return new PointageDetailInoeDocument({});
  }
  getSupplementPointageInoe(id: number) {
    return new SupplementPointageDocument({});
  }

}
export default new MockDB();